/* ============================================
   SCROLL TO TOP BUTTON FUNCTIONALITY
   ============================================ */

class ScrollToTop {
  constructor() {
    this.button = null;
    this.init();
  }

  init() {
    // Create the button element
    this.createButton();
    
    // Add event listeners
    this.addEventListeners();
  }

  createButton() {
    // Create button element
    this.button = document.createElement('button');
    this.button.className = 'scroll-to-top';
    this.button.setAttribute('aria-label', 'Scroll to top');
    this.button.setAttribute('type', 'button');
    
    // Add SVG icon (arrow up)
    this.button.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 15l-6-6-6 6"/>
      </svg>
    `;
    
    // Append to body
    document.body.appendChild(this.button);
  }

  addEventListeners() {
    // Show/hide button on scroll
    window.addEventListener('scroll', () => {
      this.handleScroll();
    });

    // Scroll to top on click
    this.button.addEventListener('click', () => {
      this.scrollToTop();
    });
  }

  handleScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    // Show button after scrolling down 300px
    if (scrollPosition > 300) {
      this.button.classList.add('visible');
    } else {
      this.button.classList.remove('visible');
    }

    // Adjust position when near bottom (to avoid covering footer content)
    if (scrollPosition + windowHeight > documentHeight - 100) {
      this.button.classList.add('near-bottom');
    } else {
      this.button.classList.remove('near-bottom');
    }
  }

  scrollToTop() {
    // Smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ScrollToTop();
  });
} else {
  new ScrollToTop();
}